import { i18n } from '@/lang/index.js'
import { addTraceStore } from '@/utils/storage.js'
import { getQueryParams, attachLocalKey } from '@/utils/common.js'
import { appNameFlag, domainNameFlag, resolvePackageShortName } from '@/commonFunc/judge-package-name.js'

import moment from 'moment'
import Decimal from 'decimal.js'
import BaseConfig from '@/config/base.js'
import Client from '@/commonFunc/client'

// 多包名称相同资源，不同设计
import allImgs from '@/assets/packageAssets/packages/index.js'

function isEmpty(val) {
  return val === undefined || val === null || val === 'undefined' || val === 'null' || val === ''
}

// 默认顶部栏padding-top
const defaultBarH = 38
// 默认底部栏
const defaultBottomBarH = 0

// prettier-ignore
const GlobalMixins = {
  data() {
    return {
      packageName: '',
      domain: window.location.hostname,
      // CDN图片路径
      imgHost: BaseConfig.imgHost,
      // 沉浸式页面设置高度
      topBarHeight: defaultBarH,
      bottomBarHeight: defaultBottomBarH,
      rtlLangs: [...BaseConfig.rtlLangs],
      incomeType: [
        {
          id: null,
          text: i18n.t('lang.BaseModule.k006')
        },
        {
          id: 2,
          text: i18n.t('lang.BaseModule.k025')
        },
        {
          id: 3,
          text: i18n.t('lang.OtherModule.k011')
        },
        {
          id: 5,
          text: i18n.t('lang.OtherModule.k010')
        },
        {
          id: 6,
          text: i18n.t('lang.BaseModule.k043')
        },
        {
          id: 15,
          text: i18n.t('lang.BaseModule.k037')
        },
        {
          id: 16,
          text: i18n.t('lang.CommonModule.k001')
        },
        {
          id: 18,
          text: i18n.t('lang.OtherModule.k012')
        }
      ],
      // 全局权益
      propsMap: {
        0: 'coin',
        1: 'chat-pass',
        2: 'video-pass',
        3: 'beans',
        4: 'vip',
        5: '?',
        6: 'call-pass',
        7: 'beer',
        8: '?',
        9: 'coupon',
        10: '?',
        11: '?',
        12: '?',
        13: '?',
        14: '?',
        15: 'super-chat-pass'
      }
    }
  },
  computed: {
    env() {
      const ua = navigator.userAgent
      let isAppIOS = false
      let isAppAndroid = false

      // prettier-ignore
      try {
        isAppIOS = this.$client.getAppInfo().deviceType === '1'
        isAppAndroid = this.$client.getAppInfo().deviceType === '0'
      }
      catch (err) {
        this.reportError(err, { method: 'env' })
      }

      return {
        // ua在app内 值是dq
        ua: ua,
        // app内可判断
        isApp: /dq/i.test(ua),
        isBrowser: !/dq/i.test(ua),
        isAppIOS: isAppIOS,
        isAppAndroid: isAppAndroid,
        // app外可判断
        isMobile: /android|iphone|ipod|ipad/i.test(ua),
        isIOS: /iphone|ipod|ipad|ios|mac os/i.test(ua),
        isAndroid: /android/i.test(ua)
      }
    },
    uid() {
      // prettier-ignore
      try {
        const USERINFO = this.$client.getUserBaseInfo()
        return USERINFO && USERINFO['uid'] ? USERINFO['uid'] : ''
      }
      catch (err) {
        this.reportError(err, { method: 'uid' })
        return ''
      }
    }
  },
  watch: {
    $route: {
      handler(newRoute, oldRoute) {
        let tempH = defaultBarH
        let tempBottomH = defaultBottomBarH
        // prettier-ignore
        try {
          if (newRoute) {
            // 处理顶部安全区
            const statusBarHeight = newRoute.query.statusBarHeight
            if (statusBarHeight) {
              window.sessionStorage.setItem('clientBarH', statusBarHeight)
              tempH = statusBarHeight ? statusBarHeight * 1 : defaultBarH
            }
            // url无
            else {
              const clientBarH = window.sessionStorage.getItem('clientBarH')
              if (clientBarH) {
                tempH = clientBarH * 1
              }
            }

            // 处理底部安全区
            let bottomBarHeight = newRoute.query.bottomBarHeight
            if (bottomBarHeight) {
              window.sessionStorage.setItem('clientBottomH', bottomBarHeight)
              tempBottomH = bottomBarHeight ? bottomBarHeight * 1 : defaultBottomBarH
            }
            // url无
            else {
              const clientBottomH = window.sessionStorage.getItem('clientBottomH')
              if (clientBottomH) {
                bottomBarHeight = clientBottomH * 1
                tempBottomH = bottomBarHeight
              }
            }
            setTimeout(() => {
              const bottomBarDoms = document.querySelectorAll('.bottomBarHeight')
              if (!bottomBarDoms.length && bottomBarHeight) {
                const targetDom = document.querySelectorAll('.containerIndex')
                if (targetDom && targetDom.length === 1) {
                  const tempDom = document.createElement('div')
                  tempDom.className = 'bottomBarHeight'
                  tempDom.style.width = '100%'
                  tempDom.style.height = `${bottomBarHeight}px`
                  targetDom[0].append(tempDom)
                }
              }
            })
          }
        }
        catch (err) {
          this.reportError(err, { method: '$route' })
        }
        // 顶部安全区
        this.topBarHeight = tempH
        this.bottomBarHeight = tempBottomH
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 统一错误上报：控制台打印 + Sentry 上报
    reportError(err, context = {}) {
      console.log('try catch err:', err)
      // prettier-ignore
      try {
        this.$sentry?.captureException(err, {
          extra: context,
          level: 'error'
        })
      }
      catch (_) {}
    },

    // 区分包-包名
    appNameFlag: appNameFlag,

    // 区分包-域名
    domainNameFlag: domainNameFlag,

    // 获取uid
    getUid() {
      // prettier-ignore
      try {
        return this.$client.getUserBaseInfo().uid
      }
      catch (err) {
        this.reportError(err, { method: 'getUid' })
        return ''
      }
    },

    getChannel() {
      // prettier-ignore
      try {
        return this.$client.getAppInfo().channel
      }
      catch (err) {
        this.reportError(err, { method: 'getChannel' })
        return ''
      }
    },

    getAppName() {
      // prettier-ignore
      try {
        return this.$client.getAppInfo().appPackageName
      }
      catch (err) {
        this.reportError(err, { method: 'getAppName' })
        return ''
      }
    },

    // 获取简单包名
    getPackageName() {
      // prettier-ignore
      try {
        const tempName = resolvePackageShortName(this.getAppName(), this.domain)
        if (tempName) this.packageName = tempName
      }
      catch (err) {
        this.reportError(err, { method: 'getPackageName' })
      }
    },

    getMatchImg(imgname, pkgName) {
      // prettier-ignore
      try {
        if (pkgName) {
          return allImgs[pkgName]?.[imgname] || ''
        }

        const tempName = resolvePackageShortName(this.getAppName(), this.domain)
        return tempName ? allImgs[tempName]?.[imgname] || '' : ''
      }
      catch (err) {
        this.reportError(err, { method: 'getMatchImg' })
        return ''
      }
    },

    getShareHost() {
      // prettier-ignore
      try {
        const tempName = resolvePackageShortName(this.getAppName(), this.domain)
        return tempName ? BaseConfig.apps[tempName]?.shareHost : null
      }
      catch (err) {
        this.reportError(err, { method: 'getShareHost' })
        return null
      }
    },

    // 跳转app
    appAction(path = '', query = '') {
      // prettier-ignore
      try {
        if (path) {
          let schemaHead = BaseConfig.apps.default.schema
          let pathMap = BaseConfig.apps.default.clientPath

          const tempName = resolvePackageShortName(this.getAppName(), this.domain)
          if (tempName) {
            schemaHead = BaseConfig.apps[tempName]?.schema
            pathMap = BaseConfig.apps[tempName]?.clientPath
          }

          if (pathMap && pathMap[path]) {
            commandRouter.postMessage(`${schemaHead}${pathMap[path]}${query}`)
          }
          //
          else {
            commandRouter.postMessage(path)
          }
        }
      }
      catch (err) {
        this.reportError(err, { method: 'appAction' })
      }
    },

    appActionPro(url = '', addQuery = {}) {
      // prettier-ignore
      try {
        const open_web_inside_arr = []
        Object.values(BaseConfig.apps).forEach((app) => {
          if (app.clientPath?.open_web_inside) {
            open_web_inside_arr.push(app.clientPath.open_web_inside)
          }
        })
        let isTargetPath = false
        for (let i = 0; i < open_web_inside_arr.length; i++) {
          if (url.indexOf(open_web_inside_arr[i]) > -1) {
            isTargetPath = true
            break
          }
        }

        // 是open_web_inside
        if (isTargetPath) {
          // imee://open_web_inside?url=xxxx?p1=xx&p2=xx
          let realUrl = ''
          const tIndex = url.indexOf('?')
          if (tIndex > -1 && url[tIndex + 1]) {
            realUrl = url.substring(tIndex + 1)
          }
          if (realUrl) {
            const realUrlArr = realUrl.split('?')
            if (realUrlArr.length > 1) {
              const originQuery = getQueryParams(realUrlArr)
              const toUrl = realUrlArr[0].replace('url=', '')
              this.$router.push({ path: toUrl, query: { ...originQuery, ...addQuery } })
            }
            //
            else {
              const toUrl = realUrl.replace('url=', '')
              this.$router.push({ path: toUrl, query: addQuery })
            }
          }
        }
        // 非open_web_inside
        else {
          console.log('🚀 ~ commandRouter.postMessage:', url)
          commandRouter.postMessage(url)
        }
      }
      catch (err) {
        this.reportError(err, { method: 'appActionPro' })
      }
    },

    // 关闭
    closeWeb() {
      // prettier-ignore
      try {
        // app内 关闭webview
        if (this.env.isApp) {
          // ios
          if (this.env.isAppIOS) {
            this.$client.closeActivityIOS()
          }
          // 非ios
          else {
            this.$client.closeActivity()
          }
          return
        }

        // app外 返回上一页
        this.$router.go(-1)
      }
      catch (err) {
        this.reportError(err, { method: 'closeWeb' })
      }
    },

    // 回退
    goPrevious() {
      // prettier-ignore
      try {
        if (this.$route.query.backType === 'close') {
          this.closeWeb()
          return
        }

        this.$router.go(-1)
      }
      catch (err) {
        this.reportError(err, { method: 'goPrevious' })
      }
    },

    goBack() {
      // prettier-ignore
      try {
        if (this.$route.query.backType === 'previous') {
          this.$router.go(-1)
          return
        }

        this.closeWeb()
      }
      catch (err) {
        this.reportError(err, { method: 'goBack' })
      }
    },

    // 返回按钮IOS 过包用 用户和隐私协议
    backIOS() {
      // prettier-ignore
      try {
        this.$client.closeActivityIOS()
      }
      catch (err) {
        this.reportError(err, { method: 'backIOS' })
      }
    },

    // 当月 开始 和 结束(时间戳)
    getMonthStartAndEnd(chooseTime) {
      // prettier-ignore
      try {
        const givenDate = new Date(chooseTime)
        const year = givenDate.getFullYear()
        const month = givenDate.getMonth()
        const startTime = new Date(year, month, 1).getTime()
        const endTime = new Date(year, month + 1, 1).getTime() - 1
        return {
          startTime: startTime,
          endTime: endTime
        }
      }
      catch (err) {
        this.reportError(err, { method: 'getMonthStartAndEnd' })
        return null
      }
    },

    // 本周 周一 和 周天(日期字符)
    getWeekStartAndEnd(date) {
      // prettier-ignore
      try {
        // 格式化日期为 yyyy-mm-dd
        function formatDate(date) {
          const year = date.getFullYear()
          const month = String(date.getMonth() + 1).padStart(2, '0')
          const day = String(date.getDate()).padStart(2, '0')
          return `${year}-${month}-${day}`
        }

        const givenDate = new Date(date)
        const dayOfWeek = givenDate.getDay()
        // 本周周一
        const monday = new Date(givenDate)
        monday.setDate(givenDate.getDate() - ((dayOfWeek + 6) % 7))
        // 本周周日
        const sunday = new Date(monday)
        sunday.setDate(monday.getDate() + 6)

        return {
          monday: formatDate(monday),
          sunday: formatDate(sunday)
        }
      }
      catch (err) {
        this.reportError(err, { method: 'getWeekStartAndEnd' })
        return null
      }
    },

    // 时间处理(传的时间戳, 格式)
    handleMoment(time, format = 'YYYY-MM-DD HH:mm:ss') {
      // prettier-ignore
      try {
        return moment(time).format(format)
      }
      catch (err) {
        this.reportError(err, { method: 'handleMoment' })
        return ''
      }
    },

    // 秒转时长文案。format 里的 d/h/m/s 会替换成「数值+单位」，其余字符原样保留
    // transformSeconds(sec, 'd:h:m') → 1d:2h:3m
    // transformSeconds(sec, 'd h')   → 1d 2h
    // transformSeconds(sec, 'h:m')   → 2h:3m
    // transformSeconds(sec, 'hms')   → 2h3m4s
    // transformSeconds(sec, 'h:m:s') → 2h:3m:4s
    transformSeconds(seconds, format = 'd:h:m') {
      // prettier-ignore
      try {
        if (!seconds) return '0'
        const duration = moment.duration(seconds, 'seconds')
        const tokens = {
          d: Math.floor(duration.asDays()),
          h: duration.hours(),
          m: duration.minutes(),
          s: duration.seconds(),
        }
        return format.replace(/[dhms]/g, (unit) => `${tokens[unit]}${unit}`)
      }
      catch (err) {
        this.reportError(err, { method: 'transformSeconds' })
        return '0'
      }
    },

    handleCopy(val, msg) {
      // prettier-ignore
      try {
        if (val) {
          const createInput = document.createElement('input')
          createInput.value = val
          document.body.appendChild(createInput)
          // 选择对象
          createInput.select()
          // 执行浏览器复制命令
          document.execCommand('Copy')
          createInput.style.display = 'none'
          if (msg) {
            Client.showToast(msg)
          }
        }
      }
      catch (err) {
        this.reportError(err, { method: 'handleCopy' })
      }
    },

    // 是否为空对象
    isEmptyObject(obj) {
      // prettier-ignore
      try {
        return Object.keys(obj).length === 0
      }
      catch (err) {
        this.reportError(err, { method: 'isEmptyObject' })
        return true
      }
    },

    // 金额分转元
    handleDiv100(val) {
      // prettier-ignore
      try {
        if (isEmpty(val)) {
          return val
        }
        return Decimal(val).div(Decimal(100)).toNumber()
      }
      catch (err) {
        this.reportError(err, { method: 'handleDiv100' })
        return val
      }
    },

    // 数字千分位展示
    thousandthDigit(num) {
      // prettier-ignore
      try {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      }
      catch (err) {
        this.reportError(err, { method: 'thousandthDigit' })
        return num
      }
    },

    // prettier-ignore
    toFixedPrice (numArg) {
      // prettier-ignore
      try {
        return Number(numArg).toFixed(2)
      }
      catch (err) {
        this.reportError(err, { method: 'toFixedPrice' })
        return numArg
      }
    },

    myPlus(a, b) {
      // prettier-ignore
      try {
        if (isEmpty(a) || isEmpty(b)) {
          return ''
        }
        return Decimal(a).plus(Decimal(b)).toNumber()
      }
      catch (err) {
        this.reportError(err, { method: 'myPlus' })
        return ''
      }
    },

    myMinus(a, b) {
      // prettier-ignore
      try {
        if (isEmpty(a) || isEmpty(b)) {
          return ''
        }
        return Decimal(a).minus(Decimal(b)).toNumber()
      }
      catch (err) {
        this.reportError(err, { method: 'myMinus' })
        return ''
      }
    },

    myTimes(a, b) {
      // prettier-ignore
      try {
        if (isEmpty(a) || isEmpty(b)) {
          return ''
        }
        return Decimal(a).times(Decimal(b)).toNumber()
      }
      catch (err) {
        this.reportError(err, { method: 'myTimes' })
        return ''
      }
    },

    myDiv(a, b) {
      // prettier-ignore
      try {
        if (isEmpty(a) || isEmpty(b)) {
          return ''
        }
        return Decimal(a).div(Decimal(b)).toNumber()
      }
      catch (err) {
        this.reportError(err, { method: 'myDiv' })
        return ''
      }
    },

    // 按出现顺序替换文案中的占位符（一个或多个）
    // replaceText(str, '%s', a) / replaceText(str, '%s', a, b)
    replaceText(str, target, ...replacements) {
      // prettier-ignore
      try {
        let result = String(str)
        const needle = String(target)
        let from = 0
        for (let i = 0; i < replacements.length; i++) {
          const index = result.indexOf(needle, from)
          if (index === -1) break
          const value = replacements[i] == null ? '' : String(replacements[i])
          result = result.substring(0, index) + value + result.substring(index + needle.length)
          from = index + value.length
        }
        return result
      }
      catch (err) {
        this.reportError(err, { method: 'replaceText' })
        return str
      }
    },

    hasEmojiCharacter(substring) {
      // prettier-ignore
      try {
        const len = substring.length
        for (let i = 0; i < len; i++) {
          const hs = substring.charCodeAt(i)

          // 高代理项（High Surrogate）
          if (hs >= 0xd800 && hs <= 0xdbff) {
            if (i + 1 < len) {
              const ls = substring.charCodeAt(i + 1)
              const uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000
              if (uc >= 0x1d000 && uc <= 0x1f77f) {
                return true
              }
            }
          }
          // 组合符号（Combining Enclosing Keycap）
          else if (i + 1 < len) {
            const ls = substring.charCodeAt(i + 1)
            if (ls === 0x20e3) {
              return true
            }
          }
          // 其他常见 Emoji 字符区间
          else {
            if (
              (hs >= 0x2100 && hs <= 0x27ff) ||
              (hs >= 0x2b05 && hs <= 0x2b07) ||
              (hs >= 0x2934 && hs <= 0x2935) ||
              (hs >= 0x3297 && hs <= 0x3299) ||
              [0xa9, 0xae, 0x303d, 0x3030, 0x2b55, 0x2b1c, 0x2b1b, 0x2b50].includes(hs)
            ) {
              return true
            }
          }
        }

        return false
      }
      catch (err) {
        this.reportError(err, { method: 'hasEmojiCharacter' })
        return false
      }
    },

    // 为列表项附加 localKey
    attachLocalKey,

    // thinkingdata 上报
    traceAction(item) {
      // prettier-ignore
      try {
        if (window.ta) {
          window.ta.track('h5_page_track', item)
        }
        // 未初始化：有 uid 缓存到用户维度，无 uid 缓存到匿名队列，待 SDK init 后统一 flush
        else {
          const uid = this.getUid()
          // 有 uid 缓存到用户维度
          if (uid) {
            addTraceStore(`thinkingdata_${uid}`, item)
          }
          // 无 uid 缓存到匿名队列
          else {
            addTraceStore('thinkingdata_anonymous', item)
          }
        }
      }
      catch (err) {
        this.reportError(err, { method: 'traceAction' })
      }
    }
  },
  created() {
    this.getPackageName()
  }
}
export default GlobalMixins
